import React from 'react';

import pluralize from 'pluralize';

import { useSelector } from 'bundles/research/index/store/hooks';
import { getCurrentTab } from '../store/selectors/ui';

import Controls from './controls';

export default function CompsIndexHeaderEdgeCrm() {
  const currentTab = useSelector(getCurrentTab);
  const totalCount = useSelector(state => state.search.meta.totalCount);

  return (
    <div className="index-page-header d-flex align-items-center p-4 border-bottom">
      <h1 className="flex-1 m-0">Comps</h1>

      {currentTab !== 'maps' &&
        <span className="text-muted">{pluralize('Comp', totalCount, true)}</span>
      }

      <Controls/>
    </div>
  );
}
